// "Modified" pill per D-58: amber, shown when value differs from pack default.
// EN: "● Modified" / ES: "● Modificado"
// VoiceSpectrum.Web.T2 · v10.0.8.5 · 2026-05-17 · VoiceSpectrum AI

interface ModifiedPillProps {
  /** The active language code, e.g. 'en' or 'es' */
  lang?: string;
}

export default function ModifiedPill({ lang = 'en' }: ModifiedPillProps) {
  const label = lang === 'es' ? 'Modificado' : 'Modified';

  return (
    <span
      className="override-pill"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.2rem',
        fontSize: '0.7rem',
        fontWeight: 600,
        padding: '2px 7px',
        borderRadius: '9999px',
        background: 'var(--pill-modified-bg)',
        color: 'var(--pill-modified-text)',
        border: '1px solid var(--pill-modified-border)',
        lineHeight: '1.4',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ fontSize: '0.55rem' }}>●</span>
      {label}
    </span>
  );
}
